import { create } from 'zustand';
import { getWaitListInfoApi } from "@/api/waitList";
const reQueryWaitListInfo = async (params?: any) => {
  const { andLoading = true } = params || {};

  // 重新进入 置空
  if (andLoading) {
    useWaitListStore.setState({ isLoadingWaitListInfo: true });
  }

  useWaitListStore.setState({ isRequestingWait: true });  // 设置请求标志
  
  getWaitListInfoApi().then((data) => {
    useWaitListStore.setState({
      waitListInfo: data,
      isLoadingWaitListInfo: false,
      isRequestingWait: false  // 重置请求标志
    });
  }).catch(() => {
    useWaitListStore.setState({ isRequestingWait: false });  // 错误时也要重置标志
  });
}

type WaitListStore = {
  waitListInfo: any;
  setWaitListInfo:  (data: any) => void;
  isLoadingWaitListInfo: boolean;
  setIsLoadingWaitListInfo: (data: boolean) => void;
  reQueryWaitListInfo:  () => void;
  isRequestingWait:  boolean;
};

export const useWaitListStore = create<WaitListStore>((set, get) => ({
  waitListInfo: null,
  setWaitListInfo: (waitListInfo: any) => set({ waitListInfo }),
  isLoadingWaitListInfo: false,
  setIsLoadingWaitListInfo: (isLoadingWaitListInfo: boolean) => set({ isLoadingWaitListInfo }),
  reQueryWaitListInfo,
  isRequestingWait: false,
}));